import type { CatalogoImpuesto, ColorImpuesto } from '@/types/impuestos'
import { COLORES_IMPUESTO } from '@/types/impuestos'

type ColorClasses = { bg: string; text: string }

const FALLBACK_COLORS: Record<string, ColorClasses> = {
  'IVA': { bg: 'bg-blue-100 dark:bg-blue-900/30', text: 'text-blue-800 dark:text-blue-300' },
  'Ganancias': { bg: 'bg-purple-100 dark:bg-purple-900/30', text: 'text-purple-800 dark:text-purple-300' },
  'IIBB': { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-800 dark:text-amber-300' },
  'IIBB Tucuman': { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-800 dark:text-amber-300' },
  'Monotributo': { bg: 'bg-green-100 dark:bg-green-900/30', text: 'text-green-800 dark:text-green-300' },
  'SUSS': { bg: 'bg-cyan-100 dark:bg-cyan-900/30', text: 'text-cyan-800 dark:text-cyan-300' },
  'Autonomos': { bg: 'bg-pink-100 dark:bg-pink-900/30', text: 'text-pink-800 dark:text-pink-300' },
}

const DEFAULT_COLOR: ColorClasses = {
  bg: 'bg-gray-100 dark:bg-gray-800',
  text: 'text-gray-700 dark:text-gray-300',
}

export const resolveImpuestoColor = (
  tipoImpuesto: string,
  catalogo: CatalogoImpuesto[] = []
): ColorClasses => {
  const match = catalogo.find((imp) =>
    imp.nombre.toLowerCase().includes(tipoImpuesto.toLowerCase()) ||
    tipoImpuesto.toLowerCase().includes(imp.nombre.toLowerCase())
  )

  if (match) {
    const { bg, text } = COLORES_IMPUESTO[match.color as ColorImpuesto]
    return { bg, text }
  }

  return FALLBACK_COLORS[tipoImpuesto] ?? DEFAULT_COLOR
}

export const getImpuestoColorClasses = (
  tipoImpuesto: string,
  catalogo: CatalogoImpuesto[] = []
): string => {
  const { bg, text } = resolveImpuestoColor(tipoImpuesto, catalogo)
  return `${bg} ${text}`
}
